import { useDispatch } from "react-redux";
import {useLazyGetAccountQuery, useLazyGetStripeKeyQuery} from "../../../Store/Builder/techsbook.api";
import {setLoader, setStripeKey, setUserData} from "../../../Store/Slice/techsbookSlice";
import showToast from "../../Hooks/toast";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const useGetStripeKeyApi = () => {
  const dispatch = useDispatch();
  const [getStripeKey] = useLazyGetStripeKeyQuery();

  const get = () => {
    dispatch(setLoader(true));
    getStripeKey()
      .unwrap()
      .then((res) => {
        dispatch(setLoader(false));
        dispatch(setStripeKey(res?.key));
      })
      .catch((err) => {
        dispatch(setLoader(false));
        showToast(err?.data?.message ?? "Error account", "error");
      });
  };

  return {
    get,
  };
};

export default useGetStripeKeyApi;
